import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { dateConvert, formatDateObject } from "../../../utils/Helper";
import { decryptData, encryptData } from "../../../utils/encrypt";
import _ from "underscore";
import { DateObject } from "react-multi-date-picker";

export const usePing = ({ projectChanged }) => {

    const [pingData, setPingData] = useState({ api_data: [] });
    const [showPingData, setShowPingData] = useState(false);
    const [popupData, setPopupData] = useState([]);
    const [hoveredRange, setHoveredRange] = useState(null);
    const [loader, setLoader] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [filterValues, setFilterValues] = useState({ service: [], server: [], date: {} });
    const [filterCount, setFilterCount] = useState(0);
    const [time, setTime] = useState({ from: null, to: null });
    const [intervalFlag, setIntervalFlag] = useState(false);
    const [defaultClicked, setDefaultClicked] = useState(true);

    useEffect(() => {
        handleDateRange(null, true);
    }, [])

    useEffect(() => {
        const result = _.uniq(pingData?.api_data, item => `${item.service_name}-${item.server}`);
        const services = _.uniq(_.pluck(result, "service_name"));
        services?.forEach((service) => {
            const elements = document.getElementById(service);
            if (elements) {
                elements.style.backgroundColor = "#ff2727";
                elements.style.cursor = "pointer";
                elements.classList.add("ping-blink-effect");
                const handleClick = () => {
                    setPopupData(_.filter(pingData?.api_data, { service_name: service }));
                    setShowPingData(true);
                };
                elements.addEventListener("click", handleClick);
                return () => {
                    elements.removeEventListener("click", handleClick);
                    elements.classList.remove("blink-border");
                };
            }
        })
    }, [pingData])

    useEffect(() => {
        getData();
    }, [projectChanged])

    useEffect(() => {
        const interval = setInterval(() => {
            if (defaultClicked) {
                handleDateRange(null, true);
            } else {
                getData();
            }
        }, 120000);

        return () => {clearInterval(interval); sessionStorage.removeItem("inspectra_error_view")}
    }, [intervalFlag]);

    const handleDateRange = (e, defaultFlag) => {
        if (e === null) {
            const now = new DateObject();
            const oneMinuteAgo = new DateObject().subtract(5, "minute");
            const range = [new DateObject(oneMinuteAgo), new DateObject(now)];
            setHoveredRange(range);
            setTime({ from: oneMinuteAgo?.toDate(), to: now?.toDate() });
            defaultFlag && handleApplyFilters(range) && setDefaultClicked(true);
        } else {
            setHoveredRange(e);
            setDefaultClicked(false);
        }
    }

    const handleApplyFilters = (dateRange) => {
        let dates;
        if (dateRange) {
            dates = {
                from_date: dateConvert(dateRange?.[0]?.toDate(), "iso-string")?.split(".")?.[0],
                to_date: dateConvert(dateRange?.[1]?.toDate(), "iso-string")?.split(".")?.[0]
            }
        } else {
            dates = {
                from_date: formatDateObject(hoveredRange?.[0], time?.from),
                to_date: formatDateObject(hoveredRange?.[1], time?.to)
            }
        }
        const pingFilters = {
            dates: dates,
            server: filterValues?.server,
            service: filterValues?.service,
        }
        sessionStorage.setItem("pingfilters", encryptData(JSON.stringify(pingFilters)));

        // set count of filters applied
        let count = 0;
        if ((hoveredRange === undefined || _.isEmpty(hoveredRange)) && (dateRange === undefined || _.isEmpty(dateRange))) {
            count = 0;
        } else {
            count++;
        }
        Object.keys(filterValues)?.forEach((item) => {
            if (filterValues[item].length > 0) {
                count++;
            }
        })
        setFilterCount(count);
        setShowFilter(false);
        sessionStorage.getItem("inspectra_error_view") && getData();
        setIntervalFlag(!intervalFlag);
    }

    const handleDefaultFilters = () => {
        handleDateRange(null, false);
        setDefaultClicked(true);
        setFilterValues((prev) => ({ ...prev, service: [], server: [] }));
    }

    const getData = async () => {
        try {
            const selectedProject = sessionStorage.getItem("inspectra_project") ? JSON.parse(decryptData(sessionStorage.getItem("inspectra_project"))) : {};
            if (!_.isEmpty(selectedProject)) {
                setLoader(true);
                const filters = JSON.parse(decryptData(sessionStorage.getItem("pingfilters")) || "{}");
                setFilterValues((prev) => ({ ...prev, date: filters?.dates }));
                const payload = {
                    type: 'ping',
                    fromDate: filters?.dates?.from_date,
                    toDate: filters?.dates?.to_date,
                    server: _.isEmpty(filters?.server) ? undefined : filters?.server?.toString(),
                    service_name: _.isEmpty(filters?.service) ? undefined : filters?.service?.toString(),
                    project_name: selectedProject?.project_key
                }
                const response = await services.callInspectra("GET", '/elsinspectra/top', payload);
                if (response) {
                    const data = response?.data;
                    setPingData({ api_data: data });
                    setLoader(false);
                    sessionStorage.setItem("inspectra_error_view", true);
                }
            }
        } catch (error) {
            console.error("Error getting Ping API status: ", error);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        pingData, showPingData, setShowPingData, popupData, setPopupData, hoveredRange, setHoveredRange, loader, showFilter, setShowFilter, filterValues, setFilterValues, filterCount, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters
    }), [pingData, showPingData, setShowPingData, popupData, setPopupData, hoveredRange, setHoveredRange, loader, showFilter, setShowFilter, filterValues, setFilterValues, filterCount, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters])
}